import { Component } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { selectCurrentProfile } from '../profile/profile.selector';
import { selectVisual } from '../visual/visual.selector';
import { getCurrentNoteOrgWorkspace, getCurrentNoteOrgWorkspaces } from '../workspaces/workspaces.selector';
import { selectCurrentShare, selectCurrentNote } from './models';

@Component({
  selector: 'nns-share-config-popup',
  template: `
   <nns-share-config
    [note]="(note$ | async)"
    [share]="(share$ | async)"
    [workspaces]="(workspaces$ | async)"
    [visual]="(visual$ | async)"
    [currentNoteWorkspace]="(currentNoteWorkspace$ | async)"
    [profile]="(profile$ | async)"
   ></nns-share-config>
  `,
  styles: [`

  `]
})
export class ShareConfigPopupComponent {
  visual$
  note$
  share$
  workspaces$
  currentNoteWorkspace$
  profile$


  constructor(
    public _store: Store<IAppState>,
  ) {
    this.share$ = this._store.pipe(select(selectCurrentShare));
    this.visual$ = this._store.pipe(select(selectVisual));
    this.note$ = this._store.pipe(select(selectCurrentNote));
    this.workspaces$ = this._store.pipe(select(getCurrentNoteOrgWorkspaces));
    this.currentNoteWorkspace$ = this._store.pipe(select(getCurrentNoteOrgWorkspace));
    this.profile$ = this._store.pipe(select(selectCurrentProfile));
  }

}
